"use client";

import { c as _c } from "react/compiler-runtime";
import SocialStatementIcon from "@/components/user/utils/icons/SocialStatementIcon";
import CopyIcon from "@/components/utils/icons/CopyIcon";
import OutsideLinkIcon from "@/components/utils/icons/OutsideLinkIcon";
import { CicStatement } from "@/entities/IProfile";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { STATEMENT_META } from "@/helpers/Types";
import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { useCopyToClipboard } from "react-use";
import UserPageIdentityDeleteStatementButton from "./UserPageIdentityDeleteStatementButton";
export default function UserPageIdentityStatementsStatement(t0) {
  const $ = _c(46);
  const {
    statement,
    profile,
    canEdit
  } = t0;
  const [title, setTitle] = useState(statement.statement_value);
  const [, copyToClipboard] = useCopyToClipboard();
  let t1;
  if ($[0] !== copyToClipboard || $[1] !== statement.statement_value || $[2] !== title) {
    t1 = () => {
      copyToClipboard(title);
      setTitle("Copied!");
      setTimeout(() => {
        setTitle(statement.statement_value);
      }, 1000);
    };
    $[0] = copyToClipboard;
    $[1] = statement.statement_value;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleCopy = t1;
  const canOpen = STATEMENT_META[statement.statement_type].canOpenStatement;
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsTouchScreen(window.matchMedia("(pointer: coarse)").matches);
    };
    t3 = [];
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== statement.statement_type) {
    t4 = <div className="tw-flex-shrink-0 tw-w-[18px] tw-h-[18px] md:tw-w-[20px] md:tw-h-[20px] group-hover:tw-scale-105 tw-transition-transform tw-duration-150 tw-ease-out"><SocialStatementIcon statementType={statement.statement_type} /></div>;
    $[6] = statement.statement_type;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = STATEMENT_META[statement.statement_type];
  let t6;
  if ($[8] !== t5.title) {
    t6 = <span className="tw-text-sm md:tw-text-base tw-font-medium tw-text-iron-200 group-hover:tw-text-iron-100 tw-transition-colors tw-duration-150 tw-ease-out">{t5.title}</span>;
    $[8] = t5.title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-x-3">{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== canOpen || $[14] !== isTouchScreen || $[15] !== statement.statement_type || $[16] !== statement.statement_value) {
    t8 = canOpen && <><a href={statement.statement_value} target="_blank" rel="noopener noreferrer" className={`${isTouchScreen ? "tw-opacity-100" : "tw-opacity-0 group-hover:tw-opacity-100"} tw-p-1.5 tw-bg-transparent tw-cursor-pointer tw-text-xs tw-font-semibold tw-text-iron-400 hover:tw-text-iron-200 tw-border-0 focus:tw-outline-none tw-transition tw-duration-300 tw-ease-out`} data-tooltip-id={`open-statement-${statement.statement_type}`}><OutsideLinkIcon /></a>{!isTouchScreen && <Tooltip id={`open-statement-${statement.statement_type}`} place="top" positionStrategy="fixed" style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px"
      }}><span className="tw-text-xs">Open</span></Tooltip>}</>;
    $[13] = canOpen;
    $[14] = isTouchScreen;
    $[15] = statement.statement_type;
    $[16] = statement.statement_value;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = `${isTouchScreen ? "tw-opacity-100" : "tw-opacity-0 group-hover:tw-opacity-100"} tw-p-1.5 tw-bg-transparent tw-cursor-pointer tw-text-xs tw-font-semibold tw-text-iron-400 hover:tw-text-iron-200 tw-border-0 focus:tw-outline-none tw-transition tw-duration-300 tw-ease-out`;
  const t10 = `copy-statement-${statement.statement_type}`;
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <CopyIcon />;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== handleCopy || $[20] !== t10 || $[21] !== t9) {
    t12 = <button aria-label="Copy" className={t9} onClick={handleCopy} data-tooltip-id={t10}>{t11}</button>;
    $[19] = handleCopy;
    $[20] = t10;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== isTouchScreen || $[24] !== statement.statement_type) {
    t13 = !isTouchScreen && <Tooltip id={`copy-statement-${statement.statement_type}`} place="top" positionStrategy="fixed" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}><span className="tw-text-xs">Copy</span></Tooltip>;
    $[23] = isTouchScreen;
    $[24] = statement.statement_type;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== canEdit || $[27] !== profile || $[28] !== statement) {
    t14 = canEdit && <UserPageIdentityDeleteStatementButton statement={statement} profile={profile} />;
    $[26] = canEdit;
    $[27] = profile;
    $[28] = statement;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t12 || $[31] !== t13 || $[32] !== t14 || $[33] !== t8) {
    t15 = <div className="tw-flex tw-items-center tw-gap-2">{t8}{t12}{t13}{t14}</div>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
    $[33] = t8;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t15 || $[36] !== t7) {
    t16 = <div className="tw-flex tw-items-center tw-justify-between tw-w-full">{t7}{t15}</div>;
    $[35] = t15;
    $[36] = t7;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== statement.statement_value || $[39] !== title) {
    t17 = title === "Copied!" ? <span className="tw-text-primary-400">{title}</span> : statement.statement_value;
    $[38] = statement.statement_value;
    $[39] = title;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t17) {
    t18 = <div className="tw-ml-7"><span className="tw-text-sm tw-text-iron-200 tw-break-all tw-tracking-wide group-hover:tw-text-iron-100 tw-cursor-text tw-select-all tw-transition-colors tw-duration-150 tw-ease-out">{t17}</span></div>;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t16 || $[44] !== t18) {
    t19 = <li className="tw-group hover:tw-bg-white/[0.02] tw-rounded-lg tw-px-2 tw-py-2 md:tw-py-1 tw-transition-colors tw-duration-200 tw-ease-out tw-border-b tw-border-white/[0.04] md:tw-border-b-0 last:tw-border-b-0"><div className="tw-flex tw-flex-col">{t16}{t18}</div></li>;
    $[43] = t16;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
}